import { object, string } from "yup";
import type { CompanySetting } from "~/models/CompanySetting";
import type { ItandiAccount } from "./ItandiAccount";
import type { StaffAuthorization, StaffAuthParam } from "./StaffAuthorization";
import { buildDefaultStaffAuth, hasAuthorization } from "./StaffAuthorization";

export type Staff = {
	authId: number;
	authUserId: number | null;
	companyMasterId: number;
	editable: boolean;
	email: string | null;
	enabled: boolean;
	hasPassword: boolean;
	id: number;
	ktStaffId: number | null;
	name: string;
	phoneNumber: number;
	role: "member" | "officer" | "admin";
	staffAuthorization: StaffAuthorization;
};
export type StaffWithCompany = Staff & {
	companySetting: CompanySetting;
};

export type StaffLogonParams = {
	id: number;
	password?: string;
};

export type StaffParam = {
	email: string | null;
	enabled: boolean;
	name: string;
	phoneNumber: number | null;
	staffAuthorization: StaffAuthParam;
};

export const hasPermissionToMoveStatus = (account: ItandiAccount): boolean =>
	hasAuthorization(account, "enableStatus");

export const hasPermissionToOperateDeal = (account: ItandiAccount): boolean =>
	hasAuthorization(account, "enableCancel");

export const hasPermissionToOpenSetting = (account: ItandiAccount): boolean =>
	hasAuthorization(account, "enableSetting");

export const hasPermissionToCompleteStatus = (
	account: ItandiAccount
): boolean => hasAuthorization(account, "enableCompleteStatus");

export const hasPermissionToConstructionStatus = (
	account: ItandiAccount
): boolean =>
	hasPermissionToMoveStatus(account) &&
	hasAuthorization(account, "enableConstructionStatus");

export const buildDefaultStaff = (): StaffParam => ({
	email: null,
	enabled: true,
	name: "",
	phoneNumber: null,
	staffAuthorization: buildDefaultStaffAuth()
});

export const createValidationSchema = object().shape({
	email: string()
		.required("入力してください")
		.email("メールアドレスの形式を確認してください"),
	name: string().required("入力してください"),
	phoneNumber: string()
		.nullable()
		.matches(/^[-\d]*$/, {
			message: "電話番号は数字とハイフンのみで入力してください"
		})
		.test(
			"length",
			"電話番号は10桁または11桁で入力してください",
			(value: string | undefined | null) => {
				const val = value ?? "";
				if (val === "") return true;
				return [10, 11].includes(val.replace(/-/g, "").length);
			}
		)
});
